import React from 'react'

const Footer = () => {
  return (
    <div className='mx-auto max-w-sm flex flex-col content-center pb-8'>©Copyright DeepSKin 2022</div>
  )
}

export default Footer